if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}


if (!customElements.get('media-gallery-swiper')) {
  customElements.define(
    'media-gallery-swiper',
    class MediaGallerySwiper extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          thumbnailsUL: this.querySelector('[id^="GalleryThumbnails"] ul'),
        };
        this.sliders = {}
        this.mql = window.matchMedia('(min-width: 750px)');

        this.init();
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      init(){
        const isDesktop = window.matchMedia('(min-width: 990px)').matches;

        if(this.elements.thumbnails){
          this.sliders.thumbnails = new Swiper(this.elements.thumbnails, {
            spaceBetween: 10,
            slidesPerView: "auto",
            watchSlidesVisibility: true,
            watchSlidesProgress: true
          });
        }
        let viewOptions = {
          direction: 'horizontal',
          slidesPerView: 1,
          centerInsufficientSlides: true,
          speed: isDesktop ? 0 : 300,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          pagination: {
            el: '.slider-dots',
            clickable: true
          },
          on: {
            slideChange: function() {
              this.onSlideChanged()
            }.bind(this)
          }
        }
        // Sur mobile, garder le lien thumbs. Sur desktop, on gère manuellement.
        if(this.elements.thumbnails && !isDesktop){
          viewOptions['thumbs'] = {
            swiper: this.sliders.thumbnails,
          }
        }
        this.sliders.viewer = new Swiper( this.elements.viewer, viewOptions);
        this.initActiveMedia();
        if (isDesktop) this.initDesktopThumbs();
      }

      initDesktopThumbs() {
        if (!this.elements.thumbnails) return;
        const thumbItems = this.elements.thumbnails.querySelectorAll('.thumbnail-list__item');
        const viewerSlides = Array.from(this.elements.viewer.querySelectorAll('.swiper-slide[data-media-id]'));

        // Initialiser : premier slide actif
        if (viewerSlides.length) viewerSlides[0].classList.add('fade-active');

        const fadeToSlide = (targetId) => {
          // Retirer fade-active de tous les slides
          viewerSlides.forEach(s => s.classList.remove('fade-active'));
          // Ajouter fade-active au slide cible
          const target = viewerSlides.find(s => s.dataset.mediaId === targetId);
          if (target) target.classList.add('fade-active');
        };

        thumbItems.forEach((thumb) => {
          const btn = thumb.querySelector('.thumbnail');
          if (!btn) return;

          const goToSlide = () => {
            const targetId = thumb.dataset.target;
            fadeToSlide(targetId);
            // Mettre à jour l'état actif des miniatures
            thumbItems.forEach(t => {
              const b = t.querySelector('.thumbnail');
              if (b) b.removeAttribute('aria-current');
            });
            btn.setAttribute('aria-current', 'true');
          };

          btn.addEventListener('pointerenter', goToSlide);
          btn.addEventListener('click', goToSlide);
        });
      }

      onSlideChanged() {
        this.initActiveMedia();
        this.centerThumbnail();
      }

      initActiveMedia() {
        const activeMedia = this.elements.viewer.querySelector('.swiper-slide-active');
        if (!activeMedia) {
          return;
        }

        this.preventStickyHeader();
        this.playActiveMedia(activeMedia);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      restart(){
        this.sliders.viewer.slideTo(0)
      }

      centerThumbnail(){
        const activeThumb = this.elements.thumbnails.querySelector('.swiper-slide-thumb-active');
        if(activeThumb) this.elements.thumbnails.scrollTo({left: activeThumb.offsetLeft})
      }
    }
  );
}
